"use strict";
export var attrData = "data-slidetoggle";
//# sourceMappingURL=dtos.js.map